<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <header class="flex">
            <strong class="flex_fill">{{title}}</strong>
            <button class="button button-link button-icon" @click="$emit('close')">
              <span class="material-icons">close</span>
            </button>
          </header>
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

  export default {
    props:['title']
  }

</script>